export const ITEM_TYPE_TASK = 1 // deprecated
export const ITEM_TYPE_PROJECT = 2  // very deprecated
export const ITEM_TYPE_EVENT = 3
export const ITEM_TYPE_MEETING = 4
export const ITEM_TYPE_REMINDER = 5
export const ITEM_TYPE_DOCUMENT = 6
export const ITEM_TYPE_AUTOMATION = 13
export const ITEM_TYPE_COMPANY_USER = 8
export const ITEM_TYPE_TIME_REPORT = 17

// see backend const.itemType.XXX

export const EntityTypeDict = {
    1   : 'Task',
    2   : 'Project',
    3   : 'Event',
    4   : 'Meeting',
    5   : 'Reminder'
}

export function entityPrefix(entityType:EntityType | null):string {

    switch (entityType) {
        case EntityType.TASK:
            return 'task'
        case EntityType.EVENT:
            return 'event'
        case EntityType.PROJECT:
            return 'project'
        case EntityType.TIME_REPORT:
            return 'timeReport'
        case EntityType.DEPENDENCY:
            return 'dependency'
        case EntityType.DYNAMIC_MODEL:
            return 'dynamic'
        case EntityType.EXPENSE:
            return 'expense'
        case EntityType.ITEM_MODEL:
            return 'itemModel'
        default:
            return 'entity-prefix-not-set'
    }

}

export enum EntityType {
    DYNAMIC_MODEL           = 0,    // use it when model is not really an entity id DB
    TASK                    = 1,
    PROJECT                 = 2,
    EVENT                   = 3,
    MEETING                 = 4,
    REMINDER                = 5,
    DOCUMENT                = 6,
    PROJECT_USER            = 7,
    COMPANY_USER            = 8,
    CUSTOM_VIEW             = 9,
    PORTFOLIO               = 10,
    CHAT                    = 11,
    EXPENSE                 = 12,
    AUTOMATION              = 13,
    CRM_ACCOUNT             = 14,
    CRM_CONTACT             = 15,
    TASK_MESSAGE            = 16,
    TIME_REPORT             = 17,
    UPDATE_TASK             = 18,
    UPDATE_PROJECT          = 19,
    STATUS                  = 20,    // any status gd.session.statuses
    USER                    = 21,    // gd.session.user
    DEPENDENCY              = 22,
    FORM                    = 23,   // both for request forms and public forms
    RECURRENCE              = 24,   // everything but task
    NOTEPAD                 = 25,   // my notes
    GIT_REPOSITORY          = 26,
    EMAIL_TEMPLATE          = 27,
    GOAL                    = 28,
    WORKDAY                 = 29,
    CHAT_MESSAGE            = 30,
    HISTORY                 = 31,    // EntityHistoryRecord
    COMPANY                 = 32,
    COMMENT                 = 33,   // Universal comment on any entity
    RECENT_TASK             = 34,
    NOTIFICATION            = 35,       // Update model (notification)
    ITEM_MODEL              = 36,     //  used in table/list/portfolio/etc
    TASK_TYPE               = 37,
    HOURLY_COST_HISTORY     = 38,
    ATTENDANCE_EVENT        = 39,
    OFFICE                  = 40,
    CUSTOM_ENTITY           = 41,
    EXPENSE_CATEGORY        = 42,
    PROJECT_VIEW            = 43,
    TASK_TAG                = 44,
    SAVED_VIEW              = 45,
    REPORT_VIEW             = 46,
    DATA_IMPORT             = 47,
    PIN                     = 48,
    DASHBOARD               = 49,  // huh ? used in parentSelector parentFor
    DEPARTMENT              = 50,  // huh ? used in parentSelector parentFor

    // integrations start from 100...
    INTEGRATION_SLACK_CHANNEL       = 101,
    MICROSOFT_ORGANIZATION_ACCOUNT  = 102,
    MICROSOFT_ACCOUNT               = 103

}
